import type { SpeakerNotesListResult } from '../types';

/**
 * AIVA-9319: the speaker-notes card as plain Markdown, for the server thread.
 *
 * The card is client-only, so the thread stores this text instead. After a Reload
 * it renders as an ordinary reply; on a Refresh it is the key the live card pairs
 * with, so the card itself comes back.
 */
export function speakerNotesText(result: SpeakerNotesListResult): string {
  const lines = [result.header, ...result.items.map((item) => `**Slide ${item.slideNumber}:** ${item.text}`)];
  if (result.footnote) lines.push(result.footnote);
  return lines.join('\n\n');
}
